// frontend/src/context/CartContext.jsx
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// ✅ Store Zustand pour le panier
export const useCart = create(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product, quantity = 1, options = {}) => {
        const { color, size } = options;
        // Clé unique basée sur le produit + couleur + taille
        const key = `${product.id}-${color || 'none'}-${size || 'none'}`;

        set((state) => {
          const existingIndex = state.items.findIndex(
            (item) =>
              item.key === key ||
              (item.id === product.id && item.color === color && item.size === size)
          );

          if (existingIndex >= 0) {
            const updatedItems = [...state.items];
            updatedItems[existingIndex] = {
              ...updatedItems[existingIndex],
              quantity: updatedItems[existingIndex].quantity + quantity,
            };
            return { items: updatedItems };
          } else {
            return {
              items: [
                ...state.items,
                {
                  id: product.id,
                  key: key,
                  name: product.name,
                  price: product.price,
                  image: product.image,
                  quantity,
                  color: color || null,
                  size: size || null,
                  stock: product.stock,
                },
              ],
            };
          }
        });
      },

      removeItem: (key) => {
        set((state) => ({
          items: state.items.filter((item) => item.key !== key),
        }));
      },

      updateQuantity: (key, quantity) => {
        if (quantity <= 0) {
          get().removeItem(key);
          return;
        }
        set((state) => ({
          items: state.items.map((item) =>
            item.key === key ? { ...item, quantity } : item
          ),
        }));
      },

      clearCart: () => set({ items: [] }),

      getTotal: () => {
        const state = get();
        const subtotal = state.items.reduce(
          (sum, item) => sum + item.price * item.quantity,
          0
        );
        const deliveryFee = subtotal >= 25000 ? 0 : 2000;
        return subtotal + deliveryFee;
      },

      getSubtotal: () => {
        return get().items.reduce(
          (sum, item) => sum + item.price * item.quantity,
          0
        );
      },

      getCount: () => {
        return get().items.reduce((sum, item) => sum + item.quantity, 0);
      },
    }),
    {
      name: 'sunumarket-cart',
    }
  )
);

// ✅ CartProvider factice (Zustand n'en a pas besoin, mais App.jsx l'utilise)
export const CartProvider = ({ children }) => <>{children}</>;

// ✅ Export par défaut
export default useCart;